import { render, staticRenderFns } from "./ContactsEdit.vue?vue&type=template&id=71719730&lang=pug"
import script from "./ContactsEdit.vue?vue&type=script&lang=js"
export * from "./ContactsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports